import React, { Component, PropTypes } from 'react';
import { Col } from 'react-bootstrap';
import ComponentLoader from '../../../shared/utils/ComponentLoader';
import classNames from 'classnames';
import ComponentTitle from 'components/shared/ComponentTitle';
import {browserHistory} from "react-router";
import {APOLOGIES_URL} from "../../constants/URL";

class CardContainer extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    gutterSpacing: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl']),
    backgroundColor: PropTypes.string,
    overflowBackground: PropTypes.bool,
    startArticleIndex: PropTypes.number,
    edgeToEdge: PropTypes.bool,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired
      }).isRequired
    ).isRequired,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    titleType: PropTypes.string
  }

  static defaultProps = {
    gutterSpacing: 'md',
    edgeToEdge: false,
    title: '',
    titleType: 'Module Title'
  }

  state = {
    ComponentClassList: []
  }

  componentWillMount() {
    let {FRN_requestError} = this.props;
    let resourceError, isURLapologizeable;

    isURLapologizeable = this.isURLapologizeable();

    if (isURLapologizeable && FRN_requestError && FRN_requestError.length) {
      resourceError = FRN_requestError.find(({error}) => {
        return error.status === 404 || error.status === 410;
      });

      if (resourceError) {
        browserHistory.push(APOLOGIES_URL);
        return;
      }
    }

    let {ComponentClassList} = this.state;
    if (!ComponentClassList && typeof window !== 'undefined') {
      const {cards} = this.props;
      Promise.all(
        cards.map(item => {
          return ComponentLoader.importReactComponent(item.id);
        })
      ).then(CompClassList =>
        this.setState({ComponentClassList: CompClassList})
      ).catch(error => {
          throw new Error(error);
        }
      );
    }
  }

  getComponentClassList = () => {
    const {cards} = this.props;
    const classList = cards.map(item => ComponentLoader._modules[item.id]
      ? ComponentLoader._modules[item.id]
      : <h1>Module {item.id} not loadable</h1>
    ).filter(item => item !== null);

    return classList;
  }

  isURLapologizeable() {
    let path, catID = /(category\/+[0-9]+)/i;
    if (process.env.BROWSER) {
      path = window.location.pathname;
      return catID.test(path);
    }

    return false;
  }

  render() {
    const {
      FRN_rawResponses,
      startArticleIndex = 0,
      gutterSpacing,
      overflowBackground,
      backgroundColor,
      cards,
      edgeToEdge,
      title,
      titleType,
      titleColor
    } = this.props;

    let { ComponentClassList } = this.state;

    if (!ComponentClassList || ComponentClassList.length === 0) {
      ComponentClassList = this.getComponentClassList();
    }

    let offset = startArticleIndex;

    const content = ComponentClassList.map((ComponentClass, index) => {
      const { props = {}, spans = { xs: 12 } } = cards[index];
      props.startArticleIndex = offset;
      offset += props.numberOfItems || 1;
      return (
        <Col key={index} {...spans} className={`CardContainer-gutterSpacing--${gutterSpacing}`}>
          <ComponentClass FRN_rawResponses={FRN_rawResponses} {...props} edgeToEdge={edgeToEdge} spans={spans}/>
        </Col>
      );
    });
    const containerItemClassName = classNames('CardContainer', {'CardContainer-edgeToEdge': edgeToEdge});
    return (
      <div className={containerItemClassName} style={{ backgroundColor }}>
        { title ? <ComponentTitle titleType={titleType} color={titleColor} showArrow={false} title={title} /> : null }
        {content}
        {backgroundColor && overflowBackground &&
        <span className={`CardContainer-backgroundOverflow CardContainer-backgroundOverflow--${gutterSpacing}`}
              style={{ backgroundColor }} />}
      </div>
    );
  }
}

export default CardContainer;



// WEBPACK FOOTER //
// ./app/components/news/CardContainer.js